import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';
import Drawer from '../Drawer';
import { toTitleCase, useGetFieldLabel } from '../../utils';

import useStyles from './styles';

export default function FilterSort(props) {
  const {
    open,
    sort,
    options: optionsProp,
    onClose,
    onSort,
  } = props;
  const { t } = useTranslation();

  const classes = useStyles();
  const getFieldLabel = useGetFieldLabel();

  const options = useMemo(() => {
    if (optionsProp && optionsProp.length > 0) {
      return optionsProp;
    }

    return [
      { label: `${getFieldLabel('created_at')} ${t('component.sort.newest_first', 'newest first')}`, field: 'created_at', order: 'desc' },
      { label: `${getFieldLabel('created_at')} ${t('component.sort.oldest_first', 'oldest first')}`, field: 'created_at', order: 'asc' },
      { label: t('component.sort.updated_newest', 'Last updated newest first'), field: 'updated_at', order: 'desc' },
      { label: t('component.sort.updated_oldest', 'Last updated oldest first'), field: 'updated_at', order: 'asc' },
      { label: `${toTitleCase(t('entity.name', 'name'))} ${t('component.sort.a_to_z', 'A - Z')}`, field: 'name', order: 'asc' },
      { label: `${toTitleCase(t('entity.name', 'name'))} ${t('component.sort.z_to_a', 'Z - A')}`, field: 'name', order: 'desc' },
    ];
  }, [getFieldLabel, optionsProp]);

  const [position, setPosition] = useState(0);

  useEffect(() => {
    if (sort) {
      let pos = options.findIndex((c) => c.field === sort.field && c.order === sort.order);
      pos = pos === -1 ? 0 : pos;
      setPosition(pos);
    }
  }, [
    sort,
    options,
  ]);
  const handleOnChange = (e) => {
    const { value } = e.target;
    setPosition(parseInt(value, 10));
  };

  const handleOnClear = () => {
    setPosition(0);
  };

  const handleOnClose = (e) => {
    let pos = options.findIndex((c) => c.field === sort.field && c.order === sort.order);
    pos = pos === -1 ? 0 : pos;
    setPosition(pos);
    onClose(e);
  };

  const handleOnSort = (e) => {
    onSort(e, {
      sort: {
        field: options[position].field,
        order: options[position].order,
      },
    });
    onClose(e);
  };

  const renderSecondaryButtons = () => [
    {
      label: t('component.label.reset', 'Reset'),
      onClick: handleOnClear,
    },
  ];

  return (
    <Drawer
      header={t('component.label.sort', 'Sort')}
      open={open}
      onClose={handleOnClose}
      onSubmit={handleOnSort}
      submitLabel={t('component.label.apply', 'Apply')}
      secondaryButtons={renderSecondaryButtons()}
    >
      <div className={classes.content}>
        <RadioGroup name="sorts" onChange={handleOnChange} value={position}>
          {
            options.map((opt, idx) => (
              <FormControlLabel
                key={opt.label}
                control={<Radio />}
                label={<Typography variant="subtitle2">{opt.label}</Typography>}
                value={idx}
              />
            ))
          }
        </RadioGroup>
      </div>
    </Drawer>
  );
}

FilterSort.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSort: PropTypes.func,
  sort: PropTypes.instanceOf(Object),
  options: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
};

FilterSort.defaultProps = {
  open: false,
  onClose: () => {},
  onSort: () => {},
  sort: {
    field: 'created_at',
    order: 'desc',
  },
  options: [],
};
